import { render, staticRenderFns } from "./TabIntegrationActiveCampaign.vue?vue&type=template&id=2f14dcb4&scoped=true&"
import script from "./TabIntegrationActiveCampaign.vue?vue&type=script&lang=js&"
export * from "./TabIntegrationActiveCampaign.vue?vue&type=script&lang=js&"
import style0 from "./TabIntegrationActiveCampaign.vue?vue&type=style&index=0&id=2f14dcb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14dcb4",
  null
  
)

export default component.exports